export const countryCode = "91"

export const phoneNo1 = "7703849283"
export const phoneNo2 = "8586885179"
export const whatsAppNo = countryCode+phoneNo2


export const facebookAcc = "https://www.facebook.com/profile.php?id=100031395428219"
export const instaAcc = "https://www.instagram.com/sachinwebmern369/"
export const linkedin = "https://www.linkedin.com/in/sachin-kumar-2728b4287/"
